// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post, put } from '../../../../common/api'
import { ADD_COMPANY, COMPANY, DELETE_COMPANY, EDIT_COMPANY, GET_COMPANY } from '../../../../common/constant'

export const actionCompany = createAsyncThunk('appCompany/actionCompany', async (params, thunkAPI) => {
    return await post(COMPANY, params, thunkAPI)
})

export const actionAddCompany = createAsyncThunk('appCompany/actionAddCompany', async (params, thunkAPI) => {
    return await put(ADD_COMPANY, params, thunkAPI)
})

export const actionGetCompany = createAsyncThunk('appCompany/actionGetCompany', async (params, thunkAPI) => {
    return await post(GET_COMPANY, params, thunkAPI)
})

export const actionEditCompany = createAsyncThunk('appCompany/actionEditCompany', async (params, thunkAPI) => {
    return await post(EDIT_COMPANY, params, thunkAPI)
})

export const actionDeleteCompany = createAsyncThunk('appCompany/actionDeleteCompany', async (params, thunkAPI) => {
    return await post(DELETE_COMPANY, params, thunkAPI)
})

export const appCompanySlice = createSlice({
    name: 'appCompany',
    initialState: {
        //list
        loading: false,
        company: null,

        //add
        loadingAdd: false,
        addCompany: null,

        //get
        loadingGet: false,
        getCompany: null,

        //edit
        loadingEdit: false,
        editCompany: null,

        //delete
        loadingDelete: false,
        deleteCompany: null

    },
    reducers: {
        //reset or delete Add Insurance Company store data
        resetCompanyResponse: (state) => {
            state.company = null
        },
        resetAddCompanyResponse: (state) => {
            state.addCompany = null
        },
        resetGetCompanyResponse: (state) => {
            state.getCompany = null
        },
        resetEditCompanyResponse: (state) => {
            state.editCompany = null
        },
        resetDeleteCompanyResponse: (state) => {
            state.deleteCompany = null
        }
    },
    extraReducers: builder => {
        builder
            //list
            .addCase(actionCompany.pending, (state) => {
                state.loading = true
            })
            .addCase(actionCompany.fulfilled, (state, action) => {
                state.loading = false
                state.company = action.payload
            })
            .addCase(actionCompany.rejected, (state) => {
                state.loading = false
            })

            //add
            .addCase(actionAddCompany.pending, (state) => {
                state.loadingAdd = true
            })
            .addCase(actionAddCompany.fulfilled, (state, action) => {
                state.loadingAdd = false
                state.addCompany = action.payload
            })
            .addCase(actionAddCompany.rejected, (state) => {
                state.loadingAdd = false
            })

            //get
            .addCase(actionGetCompany.pending, (state) => {
                state.loadingGet = true
            })
            .addCase(actionGetCompany.fulfilled, (state, action) => {
                state.loadingGet = false
                state.getCompany = action.payload
            })
            .addCase(actionGetCompany.rejected, (state) => {
                state.loadingGet = false
            })

            //edit
            .addCase(actionEditCompany.pending, (state) => {
                state.loadingEdit = true
            })
            .addCase(actionEditCompany.fulfilled, (state, action) => {
                state.loadingEdit = false
                state.editCompany = action.payload
            })
            .addCase(actionEditCompany.rejected, (state) => {
                state.loadingEdit = false
            })

            //delete
            .addCase(actionDeleteCompany.pending, (state) => {
                state.loadingDelete = true
            })
            .addCase(actionDeleteCompany.fulfilled, (state, action) => {
                state.loadingDelete = false
                state.deleteCompany = action.payload
            })
            .addCase(actionDeleteCompany.rejected, (state) => {
                state.loadingDelete = false
            })
    }
})
export const { resetCompanyResponse, resetAddCompanyResponse, resetGetCompanyResponse, resetEditCompanyResponse, resetDeleteCompanyResponse } = appCompanySlice.actions

export default appCompanySlice.reducer